import React from "react";
import styles from "./ImageGrid.module.scss";
import { ImageGridOptionsType } from "@/types/ModuleOptionsType";
import { Modul_Bild_Grid } from "../../wp/types/acf-module-types";
import { Section } from "../../components/Section/Section";
import { FadeInUp } from "../../components/Animation/ScrollAnimation";
import ImageGridCard from "./ImageGridCard";
import {
  getItemWidthBreakpoints,
  Grid,
  GridContent,
  GridItem,
} from "@aleksundshantu/aunds-utils-react/primitives/grid";
import { useSublinesVisibility } from "../../hooks/useSublinesOverlinesVisibility";
import { checkModuleIsHidden } from "@/utils/checkModuleIsHidden";
import { Headline } from "@/components/Headline/Headline";
import { useRouter } from "next/router";

export type ImageGridType = Modul_Bild_Grid;

interface ImageGridProps {
  data: ImageGridType;
  imageGridOptions: ImageGridOptionsType;
}

const ImageGridModule = ({ data, imageGridOptions }: ImageGridProps) => {
  const {
    section_padding_class,
    section_margin_class,
    background_color_class,
    id,
    headline_text_align_class,
    grid_columns,
    posts_per_page,
  } = data.layout;

  const {
    show_overline_subline,
    button_type,
    box: { show_border_radius, show_box_shadow, show_card_box },
    show_extended_link,
    media_format,
    grid_options: { text_align_class, grid_columns_choices },
  } = imageGridOptions;
  const router = useRouter();
  const {
    headline,
    headline_html_tag,
    subline,
    overline,
    elements,
    type,
    grid_type,
  } = data.image_grid;
  const fallbackItemWidth = {
    mobile: "100%",
    tablet: "50%",
    desktop: "33.3333333%",
    widescreen: "33.3333333%",
    fullhd: "33.3333333%",
    ultrahd: "33.3333333%",
  };
  const itemWidth = getItemWidthBreakpoints(
    grid_columns_choices,
    grid_columns,
    fallbackItemWidth,
  );

  const { showOverline, showSubline } = useSublinesVisibility(
    show_overline_subline,
  );

  const overline_subline = showOverline ? overline : showSubline ? subline : "";

  {
    /* jscpd:ignore-start */
  }
  //! check if module is hidden
  const isHidden = checkModuleIsHidden(data.settings);
  if (isHidden) {
    return null;
  }
  {
    /* jscpd:ignore-end */
  }

  return (
    <Section
      id={id}
      className={`image-grid ${styles["image-grid"]}  ${background_color_class} ${section_padding_class} ${section_margin_class}`}
      disableColumns
      disableClip
    >
      <div className="columns is-multiline is-centered">
        {(headline || overline_subline) && (
          <div className="column is-12">
            <FadeInUp>
              <Headline
                headline_html_tag={headline_html_tag}
                headline={headline}
                extraClass={headline_text_align_class}
                overline={showOverline ? overline_subline : ""}
                subline={showSubline ? overline_subline : ""}
                syncAnimation
                disableAnimation
              />
            </FadeInUp>
          </div>
        )}

        <div className="column is-12">
          <FadeInUp>
            <Grid
              key={router.locale}
              postsPerPage={posts_per_page}
              fetchItems={() => {
                return {
                  posts: elements ? elements : [],
                  totalPosts: elements ? elements.length : 0,
                };
              }}
              showAllPages
              // refreshKey={router.locale}
            >
              {(elements) => {
                return (
                  <>
                    <GridContent gap="2rem">
                      {elements.map((element, key) => {
                        return (
                          <GridItem
                            key={key}
                            itemWidth={itemWidth}
                            itemHeight={"100%"}
                            className={styles["grid-item"]}
                          >
                            <ImageGridCard
                              buttonType={button_type}
                              type={type}
                              element={element}
                              gridType={grid_type}
                              textAlignClass={text_align_class}
                              showExtendedLink={show_extended_link}
                              mediaFormat={media_format}
                              showBorderRadius={show_border_radius}
                              showBoxShadow={show_box_shadow}
                              showBox={show_card_box}
                              heading_level={headline ? 3 : 2}
                            />
                          </GridItem>
                        );
                      })}
                    </GridContent>

                    {/* <GridPagination /> */}
                  </>
                );
              }}
            </Grid>
          </FadeInUp>
        </div>
      </div>
    </Section>
  );
};

export default ImageGridModule;
